<template>
  <div id="app_body">
    <MsgHeader id="MsgHeader" :title="title" :subtitle="subtitle" :version_info="version">
      <b>HEADER HERE</b>
    </MsgHeader>
    <!-- <MsgMediaStage
             :class="media_stage_state"
             v-on:media_stage_toggle="media_stage_toggle"
             :show_player="media_stage_state"
     ></MsgMediaStage>
     -->
    <div id="msg_messages">
      <!--
      <div id="MsgVideoChat" v-if="chat_mode==='video_chat'">
        <MediaPlayer :requested_clip="clip">/
        </MediaPlayer>
      </div>
      -->
      <MsgHistory :messages="messages" :bot="bot"></MsgHistory>
    </div>

    <InputBar
      id="InputBar"
      v-on:update:messages="handleNewMessage"
      v-bind:listen_for_input="listen_for_input"
    ></InputBar>
  </div>
</template>

<script>
    const version = "Version v9.01 (April 11 , 2022)";
    import axios from 'axios';
    import MsgHeader from '../components/MsgHeader';
    import MsgHistory from '../components/MsgHistory';
    // import MsgMediaStage from '@/components/MsgMediaStage';
    /* import MsgInputBar from '@/components/MsgInputBar'; */
    import InputBar from '../components/InputBar';
    //import Player from '@/components/Player';
    // import MediaPlayer from '@/components/MediaPlayer';
    import store from '../store';
    import {mapState} from 'vuex';
    import {EventBus} from "../components/EventBus";


    // import MsgControlBar from './components/MsgControlBar';

    //TODO:  Consider replacing this dependency on pb-util by creating your own decode for the prototypebuff that DialogFlow is returning
    // Seems to use a keyword "struct", maybe not a JS keyword..
    // https://github.com/callmehiphop/pb-util
    // More info: https://stackoverflow.com/questions/49046140/how-to-deserialize-custom-payload-response-in-dialogflow-v2
    //const {struct} = require('pb-util');
    import {struct} from 'pb-util';


    let audio_buffer;
    let audio_is_playing = false;

    console.log(`Audio is playing: ${audio_is_playing}`);

    function playByteArray(audio_done) {
        let byteArray = audio_buffer.data;
        let arrayBuffer = new ArrayBuffer(byteArray.length);
        let bufferView = new Uint8Array(arrayBuffer);

        function play_it(buf) {
            audio_is_playing = true;

            let context =  new (window.AudioContext || window.webkitAudioContext);
            let source = context.createBufferSource();
            if (typeof (audio_done) === "function") {
                console.log("Audio ended with 'ended' event");
                audio_is_playing = false;
                source.onended = audio_done;
            }
            source.buffer = buf;
            source.connect(context.destination);
            source.start(0);
        }

        for (let i = 0; i < byteArray.length; i++) {
            bufferView[i] = byteArray[i];
        }

        let context =  new (window.AudioContext || window.webkitAudioContext);
        context.decodeAudioData(
            arrayBuffer,
            function (buffer) {
                play_it(buffer);
            }.bind(this)
        );

    }


    export default {
        name: 'app',
        components: {
            MsgHeader,
            MsgHistory,
            //  MsgMediaStage,
            // Player,
            //MediaPlayer,
            InputBar,
        },
        store,
        mounted() {

            //OBSOLETE  store.dispatch("get_video_index");
            this.bot_name = this.$route.params.bot_name || 'Name not found in params';
          //  const get_bot_list_url = `https://chatterbox.usefulbots.com/fn/get_bot_list?name=${this.bot_name}`;
          //const get_bot_list_url = `https://germanchatterbox.usefulbots.com/fn/get_bot_list?name=${this.bot_name}`;
          const get_bot_list_url = `https://chat.germanchatterbox.com/fun/get_bot_list?name=${this.bot_name}`;
          const get_bot = async () => {
                let bot_list = await axios.get(get_bot_list_url);
                bot_list = bot_list.data;
                this.bot = bot_list[0] || null;
                this.title = `${this.bot_name}'s ChatterBox (${this.version})`,
                    document.title = this.title;
            };
            get_bot();
        },
        updated() {
            this.bot_name = this.$route.params.bot_name || 'Name not found in params';
        },
        created() {
            EventBus.$on('media_ended', () => {
                console.log("VIDEO ENDED EVENT DETETED IN BOT.VUE");
                this.show_messages_after_media();
            });
        },
        watch: {
            messages: function(){
                this.$nextTick(this.scrollHistory);
            }
        },
        data() {
            return {
                speech_recognition_works: false,
                version: version,
                get_audio: true,
                title: `German ChatterBox - ${version}`,
                subtitle: 'Herzlich willkommen!',
                bot_name: 'bot name not set',
                bot: {},
                dialog_flow_contexts: [],
                messages: [
                    {
                        msgText: `Hier kannst du mit ${this.$route.params.bot_name} chatten.`,
                        name: this.$route.params.bot_name || 'Zack',
                        from: "bot",
                        timestamp: (new Date()).getTime() + 1
                    }
                ],
                messages_after_media: [],
                media_stage_state: 'compact',
                listen_for_input: false,
                clip: null,
                intent_confidence: null,
                video_chat_mode: false,
                clip_count: 0, /* TODO: same logic as in mediaPlayer, consolidate to vuex store? */
            }

        },
        computed: {
            chat_mode() {
                return store.state.chat_mode;
            },
            debug_on() {
                return store.state.debug_on;
            },
            computed_bot_name() {
                return this.$route.params.bot_name;
            },

            ...mapState(['recognition_on', 'video_index', 'video_id'])
        },
        methods: {

            update_listening: function (listening_on) {
                console.warn("App.vue: Got an Update Listening Event with value:", listening_on);
                this.listen_for_input = listening_on;
                if (listening_on) {
                    store.dispatch('recognition_on')
                } else {
                    store.dispatch('recognition_off')
                }
            },
            handleNewMessage: async function (message) {
                if (message.match(/debug/i)) {
                    console.log("Debug Mode Request");
                    let current_debug = store.state.debug_on;
                    if (current_debug) {
                        console.log("Setting Debug mode to false");
                        store.dispatch("set_debug_mode", false)
                    } else {
                        console.log("Setting Debug mode to false");
                        store.dispatch("set_debug_mode", true)
                    }
                    this.messages.push({
                        from: "user",
                        msgText: `Debug Mode Set to ${store.state.debug_on} `
                    });
                    return;
                }
                this.listen_for_input = false;
                console.log("GOT NEW MESSAGE:");
                console.dir(message);
                this.messages.push({
                    from: "user",
                    msgText: message
                });
                this.askDialogFlow(message);
            },
            show_messages_after_media: function () {
                while (this.messages_after_media.length) {
                    const nudge_message = this.messages_after_media.shift();
                    this.messages.push({
                        msgText: nudge_message,
                        from: "bot",
                        timestamp: (new Date()).getTime()
                    });
                }
            },
            media_stage_toggle: function () {
                if (this.media_stage_state === 'compact') {
                    this.media_stage_state = 'expanded'
                } else {
                    this.media_stage_state = 'compact'
                }
            },
            scrollHistory: function () {
                //var messageDisplay = document.getElementById('MsgHistory');
                let messageDisplay = document.getElementById('msg_messages');
                messageDisplay.scrollTop = messageDisplay.scrollHeight;
            },
            askDialogFlow: async function (question) {
                if (!question || !(question.length)) {
                    console.warn("question passed to DF, but question empty string or missing");
                    return;
                }
                // STOP MICROPHONE
                store.dispatch("recognition_off");

                //TODO: Set the Bot Name here based on the ROUTE URL
              //  let request_url = 'https://us-central1-zack-vfkipo.cloudfunctions.net/api/askDialogFlow';
              // request_url = 'https://chatterbox.usefulbots.com/fn/askDialogFlow';
              //request_url = 'http://localhost:5001/chatterbox-2-0/us-central1/askDialogFlow';
              // request_url = 'https://germanchatterbox.usefulbots.com/fn/askDialogFlow';
              let request_url = 'https://chat.germanchatterbox.com/fun/askDialogFlow';

              if (!this.bot_name.length) {
                    console.dir(this);
                    let route_says_botname = this.$route.params.bot_name;
                    alert(`Asking for bot without botname! computed bot name? ${this.computed_bot_name}\nRoute Says: ${route_says_botname}`);
                }
                let post_data = JSON.stringify(
                    {
                        "bot_name": this.$route.params.bot_name,
                        "question": question,
                        "contexts": this.dialog_flow_contexts,
                        "audio": (this.get_audio),
                        "video_chat": (this.video_chat_mode)
                    }
                );
                console.log(`Getting DF for bot:this.bot_name: ${this.bot_name}, from $route: ${this.$route.params.bot_name} or computed: ${this.computed_bot_name}`);
                console.log("POSTING:");
                console.dir(post_data);
                console.log("/POSTING");
                let df_response = await fetch(request_url, {
                    method: 'post',
                    body: post_data
                });
                let data2 = await df_response.json();

                console.log("DIALOG FLOW RESPONSE:");
                console.dir(data2, {depth: 7});
                console.log("/DIALOG FLOW RESPONSE");
                if (data2.intentDetectionConfidence) {
                    this.intent_confidence = data2.intentDetectionConfidence;
                    console.log("CONFIDENCE: ", this.intent_confidence)
                }
                if (data2.outputContexts){
                  this.dialog_flow_contexts = data2.outputContexts;
                  console.log("Setting contexts to :");
                  console.dir(this.dialog_flow_contexts);
                }

                this.df_text_response = data2.fulfillmentText;

                // Show text first by pushing message
                if (this.df_text_response) {
                    this.messages.push({
                        msgText: this.df_text_response.toString(),
                        from: "bot",
                        timestamp: (new Date()).getTime()
                    });
                }
                //Start listening for more input
                console.log("Message pushed, start listening for more input");
                //TODO: Dont' enable input until audio or video clip is DONE
                this.listen_for_input = true;

                if (data2.fulfillmentMessages) {
                    let payloads = data2.fulfillmentMessages.filter(msg => {
                        if (msg.payload) {
                            return msg
                        }
                    });
                    let message = payloads[Math.random() * payloads.length | 0];
                    console.log("====Selected Random Payload=====");
                    // data2.fulfillmentMessages.forEach(message => {
                    if (message && message.message === 'payload') {
                        let decoded_payload = struct.decode(message.payload);
                        let payload_type = decoded_payload.payload_type ? decoded_payload.payload_type : null;
                        console.log("PAYLOAD TYPE: ", payload_type);
                        if (payload_type === 'Image') {
                            console.log("WE HAVE IMAGE");
                            console.log(message.payload.fields.url.stringValue);
                            let image_url = message.payload.fields.url.stringValue;
                            let image_title = message.payload.fields.title.stringValue;
                            this.messages.push({
                                image: image_url,
                                title: image_title,
                                from: "bot"
                            })
                        } else if (payload_type === 'Audio Clip') {
                            this.messages.push(
                                {
                                    from: "bot",
                                    audio_clip: {
                                        url: decoded_payload.url || null,
                                        desc: decoded_payload.description || null
                                    }
                                }
                            );
                        } else if (payload_type === 'Formatted Message') {
                            if (decoded_payload.message) {
                                console.log("FORMATTED MESSAGE:");
                                console.log(decoded_payload.message);
                                console.log("/FORMATTED MESSAGE:");

                                this.messages.push({
                                    formatted_message: decoded_payload.message,
                                    from: "bot",
                                    timestamp: (new Date()).getTime()
                                });
                            }
                        } else if (payload_type === 'Video Clip') {
                            console.log("WE HAVE VIDEO CLIP");
                            // Get video URL and play video.
                            // Disable recognition while playing!a
                            console.log("VIDEO CLIP PAYLOAD TO PARSE");
                            console.dir(decoded_payload);
                            console.log("/VIDEO CLIP PAYLOAD TO PARSE");
                            let video_url = decoded_payload.clip_url;
                            if (decoded_payload.youtube_id) {
                                video_url = `https://youtube.com/embed/${decoded_payload.youtube_id}?controls=0&rel=0`
                            } else if (video_url.match(/player\.vimeo\.com/i)) {
                                // If vimeo player, add the autoplay parameter
                                if (!video_url.match(/autoplay=/)) {
                                    video_url = video_url + "?autoplay=1"
                                }
                            }
                            if (decoded_payload['hint_after']) {
                                const message = decoded_payload['hint_after'];
                                this.messages_after_media.push(message);
                            }
                            const new_player_id = "player_" + new Date().getTime();
                            this.messages.push(
                                {
                                    p_id: new_player_id,
                                    from: "bot",
                                    video_clip: {
                                        url: video_url || null,
                                        caption: decoded_payload.caption_text || null
                                    }
                                }
                            );
                            // Get the player and disable recognition on "play" event
                            // restore recognition on 'paused' and 'ended' events

                        } else if (payload_type === 'Video Chat') {
                            console.log("WE HAVE VIDEO CHAT CLIP");
                            // Show text first by pushing message
                            let clip2 = struct.decode(message.payload);
                            console.log("VIDEO CHAT payload value decoded:");
                            console.dir(clip2);
                            console.log("/VIDEO CHAT payload value decoded:");
                            store.dispatch('recognition_off');
                            let clip = message.payload.fields.clip ? message.payload.fields.clip.stringValue : null;
                            if (clip) {
                                console.log("CLIP DATA:");
                                console.dir(clip);
                                console.log("/CLIP DATA");
                                /*
                            this.messages.push({
                                msgText: `Start video chat with the clip: ${clip} `,
                                from: "bot",
                                timestamp: (new Date()).toISOString()
                            });
                             */
                                if (this.chat_mode === 'video_chat') {
                                    this.video_chat(clip);
                                } else {
                                    this.text_chat(clip);
                                }
                            } else {
                                let clip_url = message.payload.fields.clip_url ? message.payload.fields.clip_url.stringValue : null;
                                if (clip_url) {
                                    let video_title = decoded_payload.title || 'Video Clip';
                                    this.messages.push({
                                        video: clip_url,
                                        title: video_title,
                                        from: "bot"
                                    })
                                }
                            }
                        } else if (payload_type === 'Video') {
                            console.log("WE HAVE VIDEO");
                            if (decoded_payload.video) {
                                //SINGLE VIDEO URL
                                let video_url = decoded_payload.video;
                                let video_title = decoded_payload.title || '';
                                console.log("video: ", video_url);
                                console.log("video title: ", video_title);
                                this.messages.push({
                                    video: video_url,
                                    title: video_title,
                                    from: "bot"
                                })
                            } else if (decoded_payload && decoded_payload.videos) {
                                //Pick a video from array!
                                this.play_video(decoded_payload)
                            }
                        }
                    }
                    //})
                }
                this.$nextTick(this.scrollHistory);

                if (this.chat_mode === 'audio_chat') {
                    this.audio_data = await data2.audio_data;
                    audio_buffer = await data2.audio_data;
                    this.update_listening(false);
                    this.play_audio()
                }
            },
            play_audio_done: function () {
                store.dispatch("recognition_on");
                console.log("play_audio_done:Audio is done playing");
                this.update_listening(true)
            }
            ,
            play_audio: function () {
                this.update_listening(false);
                store.dispatch("recognition_off");
                if (audio_buffer && audio_buffer.data) {
                    playByteArray(this.play_audio_done);
                } else {
                    console.warn("audio buffer is empty")
                }
            }
            ,
            play_video: function (decoded_payload) {

                //  https://www.youtube.com/embed/lux2ABqLI5E?start=7&end=10
                //  https://www.youtube.com/embed/lux2ABqLI5E?start=7&end=10&loop=1


                console.log("DECODED PAYLOAD:");
                console.dir(decoded_payload);
                console.log("/DECODED PAYLOAD:");
            }
            ,
            video_chat: function (clip) {
                this.video_chat_mode = true;
                this.clip = clip;
            },

            audio_chat: function (clip) {
                this.clip = clip;
                this.text_chat(clip);

            },

            text_chat: function (clip) {
                console.log("Text Chat for Video Clip");
                this.clip = clip;
                let responses = this.video_index[clip];
                console.log("Clip responses found:");
                console.dir(responses);
                console.log("/Clip response found");
                this.clip_count++;
                let clip_index = this.clip_count % responses.length;
                let response = responses[clip_index];
                //console.log("Selected response:");
                //console.dir(response);
                //console.log("/Selected response:");
                this.video_chat_mode = false;
                let text_message = {
                    msgText: response.desc,
                    name: "Zack",
                    from: "bot",
                    timestamp: (new Date()).getTime()
                };
                this.messages.push(text_message);
            }
        }
    }
</script>

<style>
  /*
 Base HTML setup for REM as main font sizing
   */
  html {
    font-size: 62.5%;
  }

  body {
    font-size: 1.4rem;
    /*height: 100vh;
    min-height: 100vh;
    */
  }

  /* =14px */
  /* Setup box model best practice */
  html {
    box-sizing: border-box;
/*    min-height: 100%; */
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  html, body {
   /* overflow: no-display;
    overflow-y: hidden; */
   /* height: 100%; */
    padding-bottom: 10px;

  }

  #app_body {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
    min-height: 99vh;
    max-height: 99vh
  }

  .base_block {
    /*  border: 3px solid darkgrey;
      border-radius: 0.5rem;
      */
    padding: 0.1rem;
    margin: 0.1rem;
  }

  #MsgHeader {
    grid-area: msg_header;
    height: 30px;
    border-top: 10px solid white;
  }

  #msg_messages {
    grid-area: msg_messages;
    overflow-x: scroll;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }

  #InputBar {
    grid-area: msg_input_bar;
  }

  #MsgVideoChat {
    position: relative;
    background-color: black;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #app_body {
    margin: 0;
    padding: 0;
   /* min-height: 100vh;
    max-height: 100vh;
    height: 100vh; */
/*    overflow-y: hidden;
    overflow-x: hidden; */
    /*  GRID LAYOUT */
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 40px 1fr 7rem;
    grid-template-areas: "msg_header" "msg_messages" "msg_input_bar";
  }
  /*
   #app {
     overflow-x: hidden;
     overflow-y: hidden;
   }
  */

  .compact {
    height: 2rem;
    min-height: 2rem;
    max-height: 2rem;
    transition: 200ms
  }


  .expanded {
    height: 80vmin;
    min-height: 80vmin;
    max-height: 80vmin;
    transition: 600ms
  }

  p.listening,
  p.not_listening {
    display: block;
    webkit-border-radius: 3rem;
    -moz-border-radius: 3rem;
    border-radius: 3rem;
    min-height: 100px;
    text-align: center;
    vertical-align: center;
  }

  p.listening {
    background-color: lightgreen;
    border: darkgreen;
  }

  p.not_listening {
    /*
    background-color: lightpink;
    border: darkred;
    *
     */
    background-color: antiquewhite;
    border: black;
  }


</style>
